import React, { useState } from "react";
import { Coins, Droplets, Sparkles } from "lucide-react";
import { C, FONT, fmtWaktu } from "../kota/ui";
import { Sheet, Empty } from "../kota/Sheet";

const btn = (aktif = true) => ({ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, width: "100%", padding: "13px 18px", border: 0, borderRadius: 99, background: aktif ? C.blue : "#cfcbbb", color: "#fff", fontSize: 14, fontWeight: 800, cursor: aktif ? "pointer" : "default", fontFamily: FONT });

// Air Mancur Harapan — lempar 1 koin + tulis harapan (terlihat semua warga), daftar harapan terbaru kota ini
export function AirMancurSheet({ harapan, saldo, dekat, penonton, onLempar, onClose }) {
  const [teks, setTeks] = useState("");
  const bisa = !penonton && dekat && saldo >= 1;
  return (
    <Sheet testid="air-mancur-sheet" title="Air Mancur Harapan" sub="Lempar 1 koin, tulis harapanmu untuk kota" icon={Droplets} onClose={onClose}
      footer={penonton ? <p style={{ margin: 0, fontSize: 12.5, color: C.sub, textAlign: "center" }}>Hanya warga ber-KWJ yang bisa melempar koin.</p> : (
        <div>
          <input data-testid="harapan-input" value={teks} onChange={e => setTeks(e.target.value)} maxLength={60} placeholder="Harapanmu... (boleh kosong)"
            style={{ width: "100%", boxSizing: "border-box", padding: "12px 14px", background: C.cream, border: `1.5px solid ${C.line}`, borderRadius: 14, fontSize: 14.5, fontFamily: FONT, color: C.ink, outline: "none", marginBottom: 8 }} />
          <button data-testid="lempar-koin" disabled={!bisa} onClick={() => { onLempar(teks.trim()); setTeks(""); }} style={btn(bisa)}>
            <Coins size={16} /> {!dekat ? "Dekati air mancur dulu..." : saldo < 1 ? "Koinmu habis — kerja dulu yuk" : "Lempar 1 koin"}
          </button>
          <p style={{ margin: "8px 0 0", fontSize: 11.5, color: C.sub, textAlign: "center" }}>Saldo {saldo} koin · harapan tampil untuk semua warga kota</p>
        </div>
      )}>
      <div style={{ display: "flex", flexDirection: "column", gap: 6, paddingTop: 4 }}>
        {harapan.length === 0 && <Empty icon={Sparkles} testid="harapan-kosong" text="Belum ada harapan yang dilempar. Jadilah yang pertama!" />}
        {harapan.map(h => (
          <div key={h.id} data-testid="harapan-item" style={{ display: "flex", gap: 10, alignItems: "flex-start", padding: "10px 12px", background: C.cream, borderRadius: 16 }}>
            <span style={{ width: 30, height: 30, borderRadius: 99, background: "#fdf1d6", display: "grid", placeItems: "center", flex: "none" }}><Coins size={14} color="#b7791f" /></span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <b style={{ fontSize: 13 }}>{h.nama}</b> <span style={{ fontSize: 11, color: C.sub }}>{fmtWaktu(h.created_at)}</span>
              <p style={{ margin: "2px 0 0", fontSize: 13.5, lineHeight: 1.45, color: h.teks ? C.ink : C.sub, fontStyle: h.teks ? "normal" : "italic" }}>{h.teks || "melempar koin tanpa kata-kata"}</p>
            </div>
          </div>
        ))}
      </div>
    </Sheet>
  );
}
